import React, { useEffect, useState, useContext, useMemo } from "react";
import { Typography, Box, Backdrop, CircularProgress, InputAdornment, TextField, Button, Stack, TableCell, DialogContent, IconButton, Dialog, MenuItem } from "@mui/material";
import { Search, InfoOutlined } from '@mui/icons-material';
import Header from "../layout/Header";
import SorTable from "../ui/sortable";
import { API } from "../../conf";
import { Context } from "../../App";
import moment from 'moment';
import Graph from "../ui/graph";

export default function JrnVirement() {
    const { updateConnect, exercice } = useContext(Context)
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    const editCol = {header: "", sortable: false, row: (row, index) =>
        <TableCell key={index} sx={{minWidth: '60px', maxWidth: '80px'}}>
            <IconButton aria-label="informations complémentaires" onClick={() => { setObj(row); manage_dialog(true, 'info') }}><InfoOutlined fontSize="small"/></IconButton>
        </TableCell>
    }
    const table = [
        {header: "Date", sortable: true, sortBy: el => new Date(el.date).getTime(), row: (row, index) => <TableCell key={index} align="center">{moment.utc(row.date).format('DD/MM/YYYY')}</TableCell>},
        {header: "N°", sortable: true, sortBy: el => el.num.toLowerCase(), row: (row, index) => <TableCell key={index} align="center">{row.num}</TableCell>},
        {header: "Motif", sortable: true, sortBy: el => (el.motif || '').toLowerCase(), row: (row, index) => <TableCell key={index} sx={{minWidth: '100px', maxWidth: '180px'}} align="center">{row.motif || '—'}</TableCell>},
        {header: "Compte débité", sortable: false, row: (row, index) => <TableCell key={index} sx={{minWidth: '220px'}} align="center">{get_compte_label(row.debit_compte)}</TableCell>},
        {header: "Compte crédité", sortable: false, row: (row, index) => <TableCell key={index} sx={{minWidth: '220px'}} align="center">{get_compte_label(row.credit_compte)}</TableCell>},
        {header: "Montant", sortable: true, sortBy: el => el.montant, row: (row, index) => <TableCell key={index} align="center" style={{fontWeight: 'bold'}}>{row.montant.toFixed(2)}€</TableCell>},
        {header: "Utilisateur", sortable: true, sortBy: el => get_user_label(el.user).toLowerCase(), row: (row, index) => <TableCell key={index} sx={{minWidth: '130px'}} align="center">{get_user_label(row.user)}</TableCell>},
    ]
    const [loading, setLoad] = useState(true)
    const [min_date, setMin] = useState()
    const [max_date, setMax] = useState()
    const [start_date, setStart] = useState('')
    const [end_date, setEnd] = useState('')
    const [search_input, setSearch] = useState('')
    const [journal, setJournal] = useState()
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('')
    const [obj, setObj] = useState()
    const [comptes, setComptes] = useState([])
    const [users, setUsers] = useState([])

    const eglise = useMemo(() => organisation && organisation.type === 'église' ? organisation : eglises.find(el => el._id === egliseId), [egliseId, eglises, organisation])

    function get_compte_label(num) {
        const cpt = comptes.find(c => c.num === num)
        return cpt ? `${cpt.num_compte} ${cpt.libelle}` : num
    }

    function get_user_label(userId) {
        const u = users.find(u => u._id === userId)
        return u ? [u.prenom1, u.prenom2, u.nom].filter(Boolean).join(' ') : userId
    }

    function manage_dialog(status, act) {
        setOpen(status)
        setAction(act)
        if (!status) setObj()
    }

    function get_lineargraph_data() {
        const normalized_dates = [...new Set(journal.map(v => moment.utc(v.date).format('yyyy-MM-DD')))]
        const dates = normalized_dates.map(dt => new Date(dt))
        const data = [{label: 'Virement', values: normalized_dates.map(date => journal.filter(el => moment.utc(el.date).format('yyyy-MM-DD') === date).reduce((tt, v) => tt + v.montant, 0))}]
        return {dates, data}
    }

    function get_journal(end, start) {
        if (eglise?.number) {
            setLoad(true)
            fetch(API.concat(`/virements/by/${JSON.stringify({eglise: eglise.number, $and: [{date: {$lte: new Date(end).setTime(new Date(end).getTime() + 24 * 60 * 60 * 1000)}}, {date: {$gte: new Date(start)}}]})}`), {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async res => {
                const token = res.headers.get('x-auth-token')
                if (res.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                } else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', token)
                    }
                    if (res.status === 200) {
                        const json = await res.json()
                        setJournal(json.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()))
                        const userIds = [...new Set(json.map(v => v.user))]
                        if (userIds.length > 0) {
                            fetch(API.concat(`/users/${JSON.stringify(userIds)}`), {
                                method: 'GET',
                                headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('token') }
                            }).then(async r => {
                                if (r.status === 200) setUsers(await r.json())
                            })
                        }
                    }
                    setLoad(false)
                }
            })
        }
    }

    function normalize(str) {
        return str.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9\s-,.€]/gi, '').toLowerCase()
    }

    function get_searchable(row) {
        return row.num + ' ' + (row.motif || '') + ' ' + row.montant.toFixed(2) + ' ' + get_compte_label(row.debit_compte) + ' ' + get_compte_label(row.credit_compte)
    }

    useEffect(() => {
        if (eglise?.number) {
            fetch(API.concat(`/virements/${eglise.number}/dates/min_max`), {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response => {
                const token = response.headers.get('x-auth-token')
                if (response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                } else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', token)
                    }
                    if (response.status === 200) {
                        const data = await response.json()
                        if (data.mindate && data.maxdate) {
                            const min = new Date(data.mindate)
                            const max = new Date(data.maxdate)
                            setMin(min); setMax(max)
                            setEnd(moment.utc(max).format('yyyy-MM-DD'))
                            const month_before = moment.utc(max).add(-1, 'month')
                            const start = month_before.isAfter(moment.utc(min)) ? month_before.format('yyyy-MM-DD') : moment.utc(min).format('yyyy-MM-DD')
                            setStart(start)
                            get_journal(max, month_before.isAfter(moment.utc(min)) ? month_before.format('yyyy-MM-DD') : min)
                        } else {
                            setMin(new Date(Date.now()).setDate(0))
                            setMax(new Date())
                            setEnd(moment.utc(Date.now()).format('yyyy-MM-DD'))
                            setLoad(false)
                        }
                    } else setLoad(false)
                }
            })

            const query = new URLSearchParams({eglise: eglise.number}).toString()
            fetch(API.concat(`/comptes/by?${query}`), {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response => {
                const token = response.headers.get('x-auth-token')
                if (response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                } else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', token)
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setComptes(json)
                    }
                }
            })
        }
    }, [eglise])

    useEffect(() => {
        if (organisation && organisation.type === 'fédération') {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length > 0 ? {number: {$in: agent.eglises}} : {type: 'église'})}`), {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response => {
                const token = response.headers.get('x-auth-token')
                if (response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                } else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', token)
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    }, [organisation])

    useEffect(() => {
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    }, [])

    return (
        <div style={{display: 'flex', flexDirection: 'column', paddingBottom: '30px'}}>
            <Header/>
            <Typography sx={{textAlign: 'center', marginTop: '20px', fontSize: 26}}>Journal des Virements</Typography>
            {organisation && organisation.type === 'fédération' && <TextField select size="small" label="église" sx={{alignSelf: 'end', marginBottom: 3, width: '25%', marginRight: 3, minWidth: '200px'}} value={egliseId} onChange={e => setEgliseId(old => { if (old !== e.target.value) setJournal([]); return e.target.value })}>
                {eglises.sort((a, b) => a.nom.toLowerCase() < b.nom.toLowerCase() ? -1 : 1).map(egl => <MenuItem key={egl._id} value={egl._id}>{`${egl.nom} - ${egl.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>}
            <Box sx={{paddingX: '20px', marginTop: '30px'}}>
                <Box display='flex' justifyContent='space-between' alignItems='center'>
                    <Stack direction='row' spacing={2} sx={{alignItems: 'center'}}>
                        <Typography fontWeight={600} fontSize={16}>Période:</Typography>
                        <TextField
                            size="small"
                            margin="normal"
                            sx={{minWidth: '100px'}}
                            InputLabelProps={{shrink: true}}
                            label="Date de début"
                            type='date'
                            value={start_date}
                            inputProps={{min: `${exercice}-01-01`, max: max_date ? new Date(max_date).toISOString().split("T")[0] : undefined}}
                            onChange={event => {
                                setStart(event.target.value)
                                if (end_date !== '' && (new Date(end_date).getTime() - new Date(event.target.value).getTime()) <= 0) {
                                    setEnd('')
                                }
                            }}
                        />
                        <TextField
                            size="small"
                            margin="normal"
                            sx={{minWidth: '100px'}}
                            InputLabelProps={{shrink: true}}
                            label="Date de fin"
                            type="date"
                            value={end_date}
                            inputProps={{min: start_date !== '' ? start_date : `${exercice}-01-01`, max: max_date ? new Date(max_date).toISOString().split("T")[0] : undefined}}
                            onChange={event => {
                                setEnd(event.target.value)
                                if (start_date !== '' && (new Date(event.target.value).getTime() - new Date(start_date).getTime()) <= 0) {
                                    setStart('')
                                }
                            }}
                        />
                        <Button variant="contained" disabled={start_date === '' || end_date === '' || !eglise} onClick={() => get_journal(end_date, start_date)}>Appliquer</Button>
                    </Stack>
                    <Button variant="contained" onClick={() => manage_dialog(true, 'graph')} disabled={!journal?.length > 0}>Graph</Button>
                </Box>
                <TextField
                    size="small"
                    label="Rechercher un virement par numéro, motif, compte ou montant"
                    disabled={!journal?.length > 0}
                    sx={{width: '60%', minWidth: '300px', marginTop: '10px'}}
                    value={search_input}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <Search/>
                            </InputAdornment>
                        ),
                    }}
                    onChange={event => setSearch(event.target.value)}
                />
                {journal && !loading && <SorTable data={journal.filter(row => normalize(get_searchable(row)).includes(normalize(search_input)))} table={table.concat([editCol])} rowsPerPage={50} rowsPerPageOptions={[10, 25, 50, 100, 300]}/>}
            </Box>

            <Backdrop open={loading}><CircularProgress color="inherit"/></Backdrop>
            <Dialog open={open} onClose={() => manage_dialog(false, '')} maxWidth={action === 'info' ? 'xs' : 'md'} fullWidth>
                <DialogContent>
                    {action === 'info' && obj && <Box margin='20px 10px'>
                        <Typography>Date: {moment.utc(obj.date).format('DD/MM/YYYY')}</Typography>
                        <Typography>N°: {obj.num}</Typography>
                        {obj.motif && <Typography>Motif: {obj.motif}</Typography>}
                        <Typography>Compte débité: {get_compte_label(obj.debit_compte)}</Typography>
                        <Typography>Compte crédité: {get_compte_label(obj.credit_compte)}</Typography>
                        <Typography>Montant: {obj.montant.toFixed(2)}€</Typography>
                        <Typography>Exercice: {obj.exercice}</Typography>
                        <Typography>Statut: {obj.is_cloture ? 'Clôturé' : 'En cours'}</Typography>
                        <Typography>Utilisateur: {get_user_label(obj.user)}</Typography>
                    </Box>}
                    {action === 'graph' && journal?.length > 0 && <Graph
                        data={[{label: 'Virements', value: journal.reduce((tt, v) => tt + v.montant, 0)}]}
                        line_data={get_lineargraph_data()}
                    />}
                </DialogContent>
            </Dialog>
        </div>
    )
}
